import React from 'react'
import { createRoot } from 'react-dom/client'

import { PageHistoryManager } from 'cube-react'

import './styles/index.scss'
import '@fortawesome/fontawesome-free/css/all.min.css'
import '@govbr-ds/core/dist/core.min.css'

import { initialize as initializeRoutes } from './modules/Routes'
import { registerAllViews } from './modules/ViewCatalog'
import { MainPresenter } from './modules/main/main.presenter'
import { MainView } from './modules/main/view'

registerAllViews()
initializeRoutes()

const MainPresenterFactory = () => new MainPresenter(new PageHistoryManager(true))

function App() {
    const presenter = React.useMemo(MainPresenterFactory, [])

    React.useEffect(() => {
        const handleOnComponentWillUnmount = presenter.initialize()
        return () => {
            handleOnComponentWillUnmount()
        }
    }, [presenter])

    return <MainView scope={presenter.scope} />
}

const rootElm = document.getElementById('root')
if (rootElm) {
    const root = createRoot(rootElm)
    root.render(<App />)
}
